import {Component,ElementRef,OnInit,ViewChild} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "../auth/auth.service";
import {MatStepper } from "@angular/material/stepper";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { ActivatedRoute, Router } from "@angular/router";
import { MatSnackBar } from "@angular/material";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalOptions,
  NgbModalRef,
} from "@ng-bootstrap/ng-bootstrap";
@Component({
  selector: "app-auth-profile",
  templateUrl: "./auth-profile.component.html",
  styleUrls: ["./auth-profile.component.scss"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false },
    },
  ],
})
export class AuthProfileComponent implements OnInit {
  @ViewChild("gpaInput") gpaInput: ElementRef;
  isChange: boolean = false;
  isLoading: boolean = false;
  id = "";
  profileData = [];
  personalDetailForm: FormGroup;
  academicForm: FormGroup;
  financialForm: FormGroup;
  etc: any;
  imagee = "../../../assets/images/girl_img1.svg";
  isEditable = true;
  @ViewChild("stepper", { static: false }) private myStepper: MatStepper;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private _snackBar: MatSnackBar,
    private modalService: NgbModal
  ) {}
  userData: any;
  modelOptions: NgbModalOptions = {
    backdrop: "static",
    keyboard: false,
  };
  closeResult: string;
  private modalRef: NgbModalRef;
  dropdownSettingCircle: IDropdownSettings = {
    singleSelection: false,
    idField: "etcActivityId",
    textField: "title",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    allowSearchFilter: true,
    itemsShowLimit: 3,
    enableCheckAll: false,
    closeDropDownOnSelection: false,
  };
  selectedActivity: any;
  ngOnInit(): void {
    (localStorage.setItem('activityInput',JSON.stringify(this.selectedActivities)))
    localStorage.setItem('allactivity',JSON.stringify(this.allSelectedActivities))
    this.userData = JSON.parse(localStorage.getItem("userData"));
    console.log(this.userData, "USRRR");
    this.initialiseForms();
    this.getCountryData();
    this.getEducationLevelList();
    this.getSchoolNameList();
    this.getHouseHoldListApi();
    this.getCitizenShipList();
    this.getEthnicityList();
    this.getActivityList();
    this.route.queryParams.subscribe((param) => {
      if (param["id"]) {
        this.id = param["id"];
        this.fetchProfile();
      }
    });
  }

  initialiseForms() {
    this.personalDetailForm = this.fb.group({
      name: [""],
      address: ["", [Validators.required]],
      city: ["", [Validators.required]],
      state: ["", [Validators.required]],
      countryId: ["", [Validators.required]],
      citizenshipId: ["", [Validators.required]],
      gender: ["", [Validators.required]],
      ethnicityId: ["", [Validators.required]],
      ethnicity: [""],
    });
    this.academicForm = this.fb.group({
      levelOfEduId: ["", [Validators.required]],
      schoolId: ["", [Validators.required]],
      etcActivityId: [[]],
      gpa: ["", [Validators.required]],
    });
    this.financialForm = this.fb.group({
      incomeId: ["", [Validators.required]],
      efc: [""],
    });
    this.personalDetailForm.controls.name.setValue(this.userData.name);
    this.personalDetailForm.controls.countryId.setValue(
      this.userData.countryId
    );
  }

  fetchProfile() {
    let query = "";
    this.authService.getUserProfileApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.profileData = res.data.user[0];
          this.patchProfile();
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  patchProfile() {
    this.personalDetailForm.patchValue({
      countryId: this.profileData["countryId"],
    });
  }

  getFormData() {
    if (!this.personalDetailForm.valid) {
      return this.personalDetailForm.markAllAsTouched();
    } else {
      this.myStepper.next();
    }
  }

  nextToFinancialScreen() {
    // for(let el in this.academicForm.controls) {
    //   if(this.academicForm.controls[el].errors) {

    //   }
    // }
    if (this.allSelectedActivities.length <= 0) {
     return this._snackBar.open("Please add extra curricular activity", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
    }
    if (!this.academicForm.valid) {
      return this.academicForm.markAllAsTouched();
    } else {
      this.myStepper.next();
    }
  }

  back() {
    this.myStepper.previous();
  }

  countryList = [];
  getCountryData() {
    let query = "";
    this.authService.getCountryApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.countryList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  educationList = [];
  getEducationLevelList() {
    let query = "";
    this.authService.getEducationLevelApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.educationList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  schoolNameList = [];
  getSchoolNameList() {
    let query = "";
    this.authService.getSchoolNameApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.schoolNameList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  houseHoldList = [];
  getHouseHoldListApi() {
    let query = "";
    this.authService.getHouseHoldApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.houseHoldList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  citizenshipList = [];
  getCitizenShipList() {
    let query = "";
    this.authService.getCitizenShipApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.citizenshipList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }
  ethnicityList = [];
  getEthnicityList() {
    let query = "";
    this.authService.getEthincityApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.ethnicityList = res.data.response;
          this.ethnicityList.push({
            ethnicityName: "A race or ethnicity not listed here",
            _id: "other",
          });
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  activityList = [];
  getActivityList() {
    let query = "";
    this.authService.getActivityApi(query).subscribe(
      (res) => {
        this.isLoading = false;
        if (res["message"] == "Success") {
          this.activityList = res.data.response;
        }
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  getSelectedEthnicity() {
    let val = this.personalDetailForm.controls.ethnicityId.value;
    if (val == "other") {
      this.personalDetailForm.controls.ethnicityId.setValue("");
      this.personalDetailForm.controls["ethnicityId"].setValidators([
        Validators.nullValidator,
      ]);
      this.personalDetailForm.get("ethnicityId").updateValueAndValidity();
      this.personalDetailForm.controls["ethnicity"].setValidators([
        Validators.required,
      ]);
      this.personalDetailForm.get("ethnicity").updateValueAndValidity();
      this.isChange = true;
    }
  }

  cancelInput() {
    this.isChange = false;
    this.personalDetailForm.controls.ethnicity.setValue("");
  }

  selectedActivities = [];
  allSelectedActivities = [];
  onItemSelectRole(event) {
    event["text"] = "";
    for (let i = 0; i < this.activityList.length; i++) {
      if (this.activityList[i]["etcActivityId"] == event["etcActivityId"]) {
        event["isInputFiled"] = this.activityList[i]["isInputFiled"];
      }
    }
    console.log(event, "llllkkkkkk");
    if (event["isInputFiled"] == true) {
      this.selectedActivities.push(event);
    }
    this.allSelectedActivities.push(event);
  }
  showData() {
    console.log(this.selectedActivities, "@2222");
  }
  onSelectAllRole(event) {}
  onItemDeSelectRole(event) {
    this.selectedActivities = this.selectedActivities.filter(
      (data) => data.etcActivityId != event["etcActivityId"]
    );
    this.allSelectedActivities = this.allSelectedActivities.filter(
      (data) => data.etcActivityId != event["etcActivityId"]
    );
  }

  onlyNumberKey(event) {
    return event.charCode == 8 || event.charCode == 0
      ? null
      : event.charCode >= 46 && event.charCode <= 57;
  }

  save() {
    if (this.allSelectedActivities.length <= 0) {
     return this._snackBar.open("Please add extra curricular activity", "", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: ["success"],
      });
    }
    if (
      !this.financialForm.valid ||
      !this.personalDetailForm.valid ||
      !this.academicForm.valid
    ) {
      this.financialForm.markAllAsTouched();
      this.personalDetailForm.markAllAsTouched();
      this.academicForm.markAllAsTouched();
      return;
    } else {
      let finalReq = this.personalDetailForm.value;
      if (finalReq["ethnicityId"] == "" && this.isChange == true) {
        delete finalReq["ethnicityId"];
      } else {
        delete finalReq["ethnicity"];
      }
      finalReq["levelOfEduId"] = this.academicForm.controls.levelOfEduId.value;
      finalReq["schoolId"] = this.academicForm.controls.schoolId.value;
      finalReq["gpa"] = this.academicForm.controls.gpa.value;
      finalReq["incomeId"] = this.financialForm.controls.incomeId.value;
      finalReq["efc"] = this.financialForm.controls.efc.value;
      finalReq["isProfileDone"] = true;
      finalReq["extraActivity"] = JSON.parse(localStorage.getItem('allactivity'));
      console.log(finalReq, "REQQQQ");
      this.isLoading = true;
      this.authService.updateProfileApi(finalReq).subscribe(
        (res) => {
          this.isLoading = false;
          if (res["message"] == "Success") {
            this._snackBar.open("Profile Updated successfully!", "", {
              duration: 3000,
              horizontalPosition: "right",
              verticalPosition: "top",
              panelClass: ["success"],
            });
            localStorage.setItem("activeIndex", "0");
            this.router.navigate(["main/home"]);
          }
        },

        (err) => {
          this.isLoading = false;
        }
      );
    }
  }

  OpenActivityModal(content, btn) {
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    this.allSelectedActivities = []
    this.selectedActivities = []
    if(localStorage.getItem('allactivity')) {
      this.allSelectedActivities = JSON.parse(localStorage.getItem('allactivity'));
      this.selectedActivity = this.allSelectedActivities
    } else {
      this.allSelectedActivities = []
    }
    if(localStorage.getItem('activityInput')) {
      this.selectedActivities = JSON.parse(localStorage.getItem('activityInput'));
    } else {
      this.selectedActivities = []
    }
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  closeModal() {
    this.modalRef.close();
    this.selectedActivity = [];
    this.allSelectedActivities = [];
    this.selectedActivities = []
    this.allSelectedActivities = JSON.parse(localStorage.getItem('allactivity'));
    this.selectedActivities = JSON.parse(localStorage.getItem('activityInput'));
  }

  clearExtraCurricular() {
    this.allSelectedActivities = [];
    this.selectedActivity = []
    this.selectedActivities = []
    localStorage.setItem('allactivity',JSON.stringify(this.allSelectedActivities));
    localStorage.setItem('activityInput',JSON.stringify(this.selectedActivities));
  }
  totalcount:any
  saveActivityLocal() {
    this.totalcount = 0
    localStorage.setItem('allactivity',JSON.stringify(this.allSelectedActivities));
    localStorage.setItem('activityInput',JSON.stringify(this.selectedActivities));
    this.totalcount = JSON.parse(localStorage.getItem('allactivity'))
    this.modalRef.close();
  }

  OpenModal(content, btn) {
    this.modelOptions = {
      backdrop: true,
      keyboard: false,
      centered: true,
      size: "lg",
    };
    btn &&
      btn.parentElement &&
      btn.parentElement.parentElement &&
      btn.parentElement.parentElement.blur();
    this.modalRef = this.modalService.open(content, this.modelOptions);
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  
  // END ----- Update user status block
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
